var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "23px",
    viewBox: "0 0 38 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "event_log") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.3333333,4.16666667 L24.625,4.16666667 C23.75,1.75 21.4583333,-1.13686838e-13 18.75,-1.13686838e-13 C16.0416667,-1.13686838e-13 13.75,1.75 12.875,4.16666667 L4.16666667,4.16666667 C1.875,4.16666667 0,6.04166667 0,8.33333333 L0,37.5 C0,39.7916667 1.875,41.6666667 4.16666667,41.6666667 L33.3333333,41.6666667 C35.625,41.6666667 37.5,39.7916667 37.5,37.5 L37.5,8.33333333 C37.5,6.04166667 35.625,4.16666667 33.3333333,4.16666667 Z M18.75,4.16666667 C19.8958333,4.16666667 20.8333333,5.10416667 20.8333333,6.25 C20.8333333,7.39583333 19.8958333,8.33333333 18.75,8.33333333 C17.6041667,8.33333333 16.6666667,7.39583333 16.6666667,6.25 C16.6666667,5.10416667 17.6041667,4.16666667 18.75,4.16666667 Z M22.9166667,33.3333333 L8.33333333,33.3333333 L8.33333333,29.1666667 L22.9166667,29.1666667 L22.9166667,33.3333333 Z M29.1666667,25 L8.33333333,25 L8.33333333,20.8333333 L29.1666667,20.8333333 L29.1666667,25 Z M29.1666667,16.6666667 L8.33333333,16.6666667 L8.33333333,12.5 L29.1666667,12.5 L29.1666667,16.6666667 Z",
    id: "path-1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Event-Log-Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    transform: "translate(-42.000000, -1304.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left-nav",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Event-Log-Icon---assignment_24px",
    transform: "translate(0.000000, 1273.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/action/assignment_24px",
    transform: "translate(39.206616, 28.083333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Color",
    mask: "url(#mask-2)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.250000, -2.083333)",
    id: "Rectangle-13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventLog);
export default __webpack_public_path__ + "static/media/event_log.59c25c19480bb66d48121fb3dc119026.svg";
export { ForwardRef as ReactComponent };